var render = function render(){var _vm=this,_c=_vm._self._c;return _c('QuestionResponseBars',{attrs:{"display-data":_vm.displayData,"assigned-colors":_vm.assignedColors}})
}
var staticRenderFns = []

export { render, staticRenderFns }